export default __webpack_public_path__ + "static/daikin-e476ba251091b4b09e88f8ec275923af.png";